import { DataBean } from "../DataBean";

export class BankingCheckState extends DataBean {



    public async getBankingCheckStateConstants(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBankingCheckStateConstants_Number", [id]);
    }

}